import { uuid } from "@/interfaces";
import { PropertyUnitsRepository } from "@/repositories/property-units.repository.ts";
import type { UnitForm } from "@/repositories/unit-records";

export async function searchUnits(propertyId: uuid, unitNumber: string | null, page: number, pageSize: number, sortDirection: "asc" | "desc") {
  return PropertyUnitsRepository.getUnitsForProperty(propertyId, unitNumber, page, pageSize, sortDirection);
}

export async function createPropertyUnit(unit: UnitForm & { property: uuid }) {
  return PropertyUnitsRepository.createUnit(unit);
}

export async function updatePropertyUnit(propertyId: uuid, id: uuid, updates: UnitForm) {
  return PropertyUnitsRepository.updateUnit(propertyId, id, updates);
}

export async function deletePropertyUnit(propertyId: uuid, id: uuid) {
  return PropertyUnitsRepository.deleteUnit(propertyId, id);
}
